import React from 'react';
import { Button } from '@mui/material';
import { Tooltip_Next as Tooltip } from '@zs-nimbus/core';
import { useSnackbar } from 'notistack';

const TRUNCATE_LENGTH = 40;

const CopyableLink = ({ link }: { link: string }) => {
  const { enqueueSnackbar } = useSnackbar();
  const isTruncated = link.length > TRUNCATE_LENGTH;
  const displayText = isTruncated ? `${link.slice(0, TRUNCATE_LENGTH)}…` : link;

  const copyToClipboard = () => {
    if (link) {
      navigator.clipboard.writeText(link).then(() => {
        enqueueSnackbar('Link copied to clipboard', { variant: 'success', key: Date.now() });
      });
    }
  };

  const linkElement = (
    <Button
      variant="primaryText"
      size="small"
      onClick={copyToClipboard}
      sx={{
        cursor: 'copy',
        verticalAlign: 'baseline',
        textDecoration: 'underline',
        '&:hover': { textDecoration: 'none' },
      }}>
      {displayText}
    </Button>
  );

  return isTruncated ? (
    <Tooltip content={<div style={{ maxWidth: 650, wordBreak: 'break-all' }}>{link}</div>} trigger={linkElement} />
  ) : (
    linkElement
  );
};

export default CopyableLink;
